import React, { useState, useEffect, useCallback } from 'react';
import ContextCommand from 'components/ContextCommand';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import Filtro from './Filtro';
import useReport from 'components/Report/useReport.js';
import moment from 'moment';
import Elenco from './Elenco';
import qsBuilder from 'lib/qsBuilder';
import DialogValorizzazione from './DialogValorizzazione';

export default function StrumentiElenco({ setTitle, setContextCommands }) {
	const apiRef = useGridApiRef();
	const [filtro, setFiltro] = useState({});
	const { openReport } = useReport();
	const [selectedRows, setSelectedRows] = useState([]);
	const [openDialogValorizzazione, setOpenDialogValorizzazione] = useState(false);

	const stampa = useCallback(() => {
		if (Object.keys(filtro).length === 0) {
			alert("Filtri non impostati. Filtrare e stampare l'elenco.");
			return;
		}
		if (filtro.codiceStato === 'cespiti') filtro.codiceStato = '';
		var url = "/report/strumenti?sort=codiceStato,strumentiMarche.descrizioneMarca,matricola&" + qsBuilder(filtro);
		openReport(url);
	}, [filtro, openReport]);

	const stampaReportClienti = useCallback(() => {
		var url = "/report/strumenti/clienti?sort=strumentiMarche.descrizioneMarca,matricola&";
		if (selectedRows.length === 0) {
			alert("Strumenti non selezionati. Selezionarli e stampare la proposta.");
			return;
		} else {
			if (selectedRows.length > 0) {
				url += "matricola=" + selectedRows.map(r => encodeURIComponent(r)).join(',');
			} else {
				url += qsBuilder(filtro);;
			}
			openReport(url);
		}
	}, [filtro, openReport, selectedRows]);

	const stampaValorizzazione = useCallback(() => {
		setOpenDialogValorizzazione(true);
	}, []);

	const handleConfirmValorizzazione = useCallback((data, tipo) => {
		const qs = { ...qsBuilder(filtro) };
		delete (qs.codiceStato);
		const dataValorizzazione = moment(data).format('YYYY-MM-DD');

		let url = "/report/strumentiValorizzazione/" + dataValorizzazione + "/" + tipo;

		openReport(url);
		setOpenDialogValorizzazione(false);
	}, [openReport, filtro]);


	useEffect(() => {
		setTitle('Strumenti');
		const contextCommands = [];
		contextCommands.push(<ContextCommand key="1" icon="currency-eur" onClick={stampaValorizzazione}>Valorazzazione</ContextCommand>);
		contextCommands.push(<ContextCommand key="2" icon="file-document" onClick={() => stampa()}>Elenco</ContextCommand>);
		contextCommands.push(<ContextCommand key="3" icon="file-account" onClick={() => stampaReportClienti()}>Proposta clienti</ContextCommand>);
		contextCommands.push(<ContextCommand key="4" icon="plus" onClick={() => window.open("/strumenti/new")}>Inserisci</ContextCommand>);
		setContextCommands(contextCommands);
	}, [setTitle, setContextCommands, stampaValorizzazione, stampa, stampaReportClienti]);

	return (
		<div style={{ marginBottom: 50, height: '80vh' }}>
			<Filtro filtra={setFiltro} />
			<Elenco queryString={qsBuilder(filtro)} apiRef={apiRef} setSelectedRows={setSelectedRows} />

			<DialogValorizzazione
				open={openDialogValorizzazione}
				onClose={() => setOpenDialogValorizzazione(false)}
				onConfirm={handleConfirmValorizzazione}
			/>
		</div>
	);
}